<template>
    <div class="tab-pane fade show active">
        <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
            <span class="loader"></span>
        </div>
        <div :data-crowdynews-widget="'imediamatch_team-' + team_slug">
            <!-- <script
              :src="'//widget.crowdynews.com/imediamatch_team-' + team_slug + '.js'"
              async="true"
            ></script> -->
    </div>
     <div class="tab-pane fade show active text-center" >
            <p>{{ error_msg }}</p>
        </div>
    
</div>
</template>

<script>
    export default {
        name: "Social",
        data() {
            return {
                team_slug: this.$route.params.team.split("-").pop(),
                error_msg: "",
            };
        },
        metaInfo() {
            if(!Components['TeamDetails'])
                return
            
            let title = `${Components["TeamDetails"].team.name}   Social` + " - PlanetCricket.com";
            let description = `Get the latest ${Components["TeamDetails"].team.name} Social - PlanetCricket.com`;
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
                
            }
        },
        serverPrefetch() {},
        mounted() {
            this.$loadScript('//widget.crowdynews.com/imediamatch_team-' + this.team_slug + '.js');
            var interv = setInterval(() => {
                if ($("cn-widget").length) {
                    this.is_data_ready = true;
                }
            }, 200);

            setTimeout(() => {
                clearInterval(interv);
                this.is_data_ready = true;
                if (!$("cn-widget").length) {
                    this.error_msg = "No Data Found";
                }
            }, 10000);
        },

        methods: {},
    };
</script>